// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/generations/v1/delete_generation.proto (package protos.vision.generations.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/generations/v1/delete_generation.proto.
 */
export const file_vision_generations_v1_delete_generation: GenFile = /*@__PURE__*/
  fileDesc("Ci12aXNpb24vZ2VuZXJhdGlvbnMvdjEvZGVsZXRlX2dlbmVyYXRpb24ucHJvdG8SHHByb3Rvcy52aXNpb24uZ2VuZXJhdGlvbnMudjEiiAEKF0RlbGV0ZUdlbmVyYXRpb25SZXF1ZXN0EkwKBnBhcmFtcxgBIAEoCzI8LnByb3Rvcy52aXNpb24uZ2VuZXJhdGlvbnMudjEuRGVsZXRlR2VuZXJhdGlvblJlcXVlc3QuUGFyYW1zGh8KBlBhcmFtcxIVCg1nZW5lcmF0aW9uX2lkGAEgASgJInMKGERlbGV0ZUdlbmVyYXRpb25SZXNwb25zZRJNCgZyZXN1bHQYASABKAsyPS5wcm90b3MudmlzaW9uLmdlbmVyYXRpb25zLnYxLkRlbGV0ZUdlbmVyYXRpb25SZXNwb25zZS5SZXN1bHQaCAoGUmVzdWx0YgZwcm90bzM");

/**
 * @generated from message protos.vision.generations.v1.DeleteGenerationRequest
 */
export type DeleteGenerationRequest = Message<"protos.vision.generations.v1.DeleteGenerationRequest"> & {
  /**
   * @generated from field: protos.vision.generations.v1.DeleteGenerationRequest.Params params = 1;
   */
  params?: DeleteGenerationRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.DeleteGenerationRequest.
 * Use `create(DeleteGenerationRequestSchema)` to create a new message.
 */
export const DeleteGenerationRequestSchema: GenMessage<DeleteGenerationRequest> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_delete_generation, 0);

/**
 * @generated from message protos.vision.generations.v1.DeleteGenerationRequest.Params
 */
export type DeleteGenerationRequest_Params = Message<"protos.vision.generations.v1.DeleteGenerationRequest.Params"> & {
  /**
   * @generated from field: string generation_id = 1;
   */
  generationId: string;
};

/**
 * Describes the message protos.vision.generations.v1.DeleteGenerationRequest.Params.
 * Use `create(DeleteGenerationRequest_ParamsSchema)` to create a new message.
 */
export const DeleteGenerationRequest_ParamsSchema: GenMessage<DeleteGenerationRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_delete_generation, 0, 0);

/**
 * @generated from message protos.vision.generations.v1.DeleteGenerationResponse
 */
export type DeleteGenerationResponse = Message<"protos.vision.generations.v1.DeleteGenerationResponse"> & {
  /**
   * @generated from field: protos.vision.generations.v1.DeleteGenerationResponse.Result result = 1;
   */
  result?: DeleteGenerationResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.DeleteGenerationResponse.
 * Use `create(DeleteGenerationResponseSchema)` to create a new message.
 */
export const DeleteGenerationResponseSchema: GenMessage<DeleteGenerationResponse> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_delete_generation, 1);

/**
 * @generated from message protos.vision.generations.v1.DeleteGenerationResponse.Result
 */
export type DeleteGenerationResponse_Result = Message<"protos.vision.generations.v1.DeleteGenerationResponse.Result"> & {
};

/**
 * Describes the message protos.vision.generations.v1.DeleteGenerationResponse.Result.
 * Use `create(DeleteGenerationResponse_ResultSchema)` to create a new message.
 */
export const DeleteGenerationResponse_ResultSchema: GenMessage<DeleteGenerationResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_delete_generation, 1, 0);

